import { useMemo } from "react";
import { useAppState } from "@/modules/app/useAppContext";
import { FlexListSummary } from "@/components/listSummary";
import { getMoneySavings } from "../../utils";
import { SummaryItem } from "@/components/listSummary/types";
import styles from "../../styles.module.scss";

interface DiscoverSummaryProps {
  data: SummaryItem[] | undefined;
  isLoading: boolean;
}

const SUMMARY_SKELETON_COUNT = 3;

const DiscoverSummary = ({ data, isLoading }: DiscoverSummaryProps) => {
  const { currency } = useAppState();

  const summaryDataWithInfo = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.map((item: SummaryItem) => {
      const newItem = { ...item };
      switch (newItem.label) {
        case "Money Savings":
          newItem.info =
            "Possible money savings during the selected time period";
          if (
            typeof newItem.value === "object" &&
            newItem.value !== null &&
            "min" in newItem.value &&
            "max" in newItem.value
          ) {
            newItem.value = getMoneySavings(newItem.value.min, newItem.value.max, currency);
          }
          break;
        case "Time Savings":
          newItem.info =
            "Possible time savings during the selected time period";
          break;
        default:
          break;
      }
      return newItem;
    });
  }, [data, currency]);

  return (
    <div className={styles.flexListSummary}>
      <FlexListSummary
        summary={summaryDataWithInfo || []}
        isLoading={isLoading}
        skeletonCount={SUMMARY_SKELETON_COUNT}
      />
    </div>
  );
};

export default DiscoverSummary;
